module.exports = __webpack_public_path__ + "MaterialIcons-Regular.3c3d0242794b4682460a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/iconfont/MaterialIcons-Regular.woff
// module id = 643
// module chunks = 0